import React from 'react';
import { SearchType } from 'utils/types';
import MealCategoryCard from 'components/meal-category-card';

type MealCategorySearchProps = {
  selectedResults: SearchType[];
  search: SearchType;
  refreshData: () => void;
  handleChange: (result: SearchType) => void;
};
const MealCategorySearchReults = ({
  selectedResults,
  handleChange,
  refreshData,
  search
}: MealCategorySearchProps) => {
  return (
    <MealCategoryCard
      refreshData={refreshData}
      checked={selectedResults.includes(search)}
      onChange={() => handleChange(search)}
      key={search?.id}
      data={search}
      selectedItems={selectedResults.map((r) => r.id)}
    />
  );
};

export default MealCategorySearchReults;
